export async function installProject() {
  const { PagesProject } = await import("@/pages/project");
  return PagesProject;
}
